import * as React from 'react';
import { Link } from '@mui/material';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Theme } from './theme';
import { Typography, designTokens } from '@platform-ui/design-system';
import { useLanguagePreference } from './contexts/LanguagePreferenceContext';

const StyledNavFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 16px 32px;
  text-align: center;
  color: white;
`;

const StyledCopyright = styled.div`
  margin-bottom: 16px;
`;

const StyledNavLink = styled.span`
  margin: 0 0px;
  a {
    color: ${designTokens.colors.darkEmphasisMedium};
  }
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`;

const StyledLinkContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0 12px;
`;

const links = [
  {
    id: 'FooterAbout',
    href: 'https://www.zuora.com/about/',
  },
  {
    id: 'FooterNewsPress',
    href: 'https://www.zuora.com/about/news-press/',
  },
  {
    id: 'FooterPrivacy',
    href: 'https://www.zuora.com/privacy-statement/',
  },
  {
    id: 'FooterCareers',
    href: 'https://www.zuora.com/careers/',
  },
  {
    id: 'FooterContactUs',
    href: 'https://www.zuora.com/about/contact/',
  },
];

export const Footer: React.FC = () => {
  const e2e = 'nav';
  const { t } = useTranslation();
  const { isLanguageReady } = useLanguagePreference();
  const yearRange = `2008-${new Date().getFullYear()}`;

  // Don't render footer until the preferred language is ready to prevent flash of wrong language
  if (!isLanguageReady) {
    return null;
  }

  return (
    <Theme>
      <StyledNavFooter {...(e2e && { 'data-e2e': `${e2e}-footer` })}>
        <StyledCopyright>
          <Typography
            variant="caption"
            {...(e2e && { e2e: `${e2e}-footer-copyright` })}
          >
            {t('FooterCopyright', [yearRange])}
          </Typography>
        </StyledCopyright>
        <StyledLinkContainer>
          {links.map(({ href, id }) => (
            <StyledNavLink
              key={id}
              {...(e2e && { 'data-e2e': `${e2e}-footer-${id}` })}
            >
              <Typography variant="caption">
                <Link href={href} underline="hover">
                  {t(id)}
                </Link>
              </Typography>
            </StyledNavLink>
          ))}
        </StyledLinkContainer>
      </StyledNavFooter>
    </Theme>
  );
};

export default Footer;
